import { gql } from '@apollo/client';

export const GET_FORCED_CHOICE_QUESTIONS = gql`
  query GetForcedChoiceQuestions($category: String!) {
    getForcedChoiceQuestions(category: $category) {
      _id
      prompt
      category
      options {
        label
        text
        trait
      }
    }
  }
`;

export const GET_TRAIT_ASSESSMENT_PROGRESS = gql`
  query GetTraitAssessmentProgress($category: String!) {
    getTraitAssessmentProgress(category: $category) {
      _id
      category
      answers {
        questionId
        selectedOption
      }
      isCompleted
    }
  }
`;

export const GET_ALL_TRAIT_ASSESSMENT_PROGRESS = gql`
  query GetAllTraitAssessmentProgress {
    getAllTraitAssessmentProgress {
      _id
      category
      answers {
        questionId
        selectedOption
      }
      isCompleted
    }
  }
`;
